export const ERROR_SET = "appInfo.ERROR_SET";
